import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * for legacy jike web recommend(explore) route
 */
export const Route = createFileRoute('/(legacy)/recommend')({
	loader: () => {
		throw redirect({
			to: '/explore',
			replace: true,
		})
	},
})
